import { BackButton, Button, ChipStatus, Content, ContentHeader, DialogRef, Info, LabelItem, QueryState, Stack } from 'src/app/components';
import { PageTitle } from 'src/app/components/Layout/header/HeaderTitle';
import { useSalesPromoTabDetailParticipantDetail } from './SalesPromoTabParticipantDetail.hook';
import { useRef } from 'react';
import { customLDDetailParticipantStatus } from '../SalesPromoDetailTabParticipant';
import { useSalesPromoDetailTabDetail } from '../SalesPromoDetailTabDetail.hook';
import { SalesPromoModel } from 'src/app/modules/campaign/models/SalesPromo.model';
import { SalesPromoTabParticipantPrizeList } from './SalesPromoTabParticipantPrizeList';
import { SalesPromoTabParticipantPointHistory } from './SalesPromoTabParticipantPointHistory';
import Gallery from 'src/app/components/Display/Gallery/Gallery.page';
import SelectGiftPopup from './SelectGiftPopup/SelectGiftPopup';

export default function SalesPromoTabParticipantDetail() {
  const detail = useSalesPromoDetailTabDetail();
  const generalInfo: SalesPromoModel = detail.generalInfo.data;

  const state = useSalesPromoTabDetailParticipantDetail();
  const selectGiftPopup = useRef<DialogRef>(null);
  const data = state.participantDetail.data;

  return (
    <>
      <BackButton />
      <Content>
        <ContentHeader title={'Detail Customer'} />
        <PageTitle description="Customer" breadcrumbs={state.breadcrumbs}>
          Campaign
        </PageTitle>
        <QueryState query={state.participantDetail}>
          <div className='px-8 py-6'>
            <LabelItem className='gap-1' label='Customer ID' value={data?.member_code} />
            <LabelItem className='gap-1' label='Customer Name' value={data?.fullname} />
            <LabelItem className='gap-1' label='Gender' value={data?.gender} />
            <LabelItem className='gap-1' label='Phone Number' value={data?.phone_number} />
            <LabelItem className='gap-1' label='Email' value={data?.email} />
            <LabelItem className='gap-1' label='ID Type' value={data?.identity_type} />
            <LabelItem className='gap-1' label='ID Number' value={data?.identity_number} />
            <LabelItem className='gap-1' label='ID Photo'>
              {data?.identity_image && <Gallery
                bigThumbnail={true}
                items={[{
                  id: data?.id!,
                  image: data?.identity_image,
                  thumbnail: data?.identity_image,
                  title: `${data?.id}_image`,
                }]} />}
            </LabelItem>
            <LabelItem className='gap-1' label='Customer Status'>
              <div>
                <ChipStatus state="custom" customOpt={customLDDetailParticipantStatus(data?.status)} />
              </div>
            </LabelItem>
            {generalInfo?.is_direct_cashback_point &&
              <>
                <LabelItem className='gap-1' label='Total Point Earned' value={data?.total_point_earned} />
                <SalesPromoTabParticipantPointHistory data={data} />
              </>
            }
            {!generalInfo?.is_direct_cashback_point &&
              <>
                <LabelItem className='gap-1' label='Total Prize Earned' value={data?.total_prize_earned} />
                <LabelItem className='gap-1' label='Total Prize Claimed' value={data?.total_prize_claimed} />
                <LabelItem className='gap-1' label='Total Expired Receipt' value={data?.total_expired_receipt} />
                {generalInfo?.is_mission_collect_stamp && <> <LabelItem className='gap-1' label='Mission Round Completed' value={data?.total_mission_completed} />
                  <LabelItem className='gap-1 items-center' label='Stamps Collect'>
                    <Stack direction='row' className='items-center'>
                      <p className='text-xs'>
                        {data?.stamp_count ?? '-'} of {data?.total_stamp_per_round ?? '-'}
                      </p>
                      <Button loading={false} variant="outlined" className='text-xs' disabled={!data?.can_select_prize} onClick={() => (selectGiftPopup.current?.show())}>
                        Select Gift
                      </Button>
                    </Stack>
                  </LabelItem>
                </>}
                {data?.campaign_notes &&
                  <Info
                    className='mt-6'
                    severity="danger"
                    bordered={true}
                    autoHide={false}
                  >
                    {data.campaign_notes}
                  </Info>
                }
                <SalesPromoTabParticipantPrizeList data={data} generalInfo={generalInfo}></SalesPromoTabParticipantPrizeList>
              </>
            }
          </div>
        </QueryState>
      </Content>
      <SelectGiftPopup dialogRef={selectGiftPopup} params={{ campaign_id: generalInfo?.campaign_id, member_id: data?.id, mission_stamp_id: data?.mission_stamp_id }}></SelectGiftPopup>
    </>
  )
}